import { useState } from "react";
import { Modal } from "react-bootstrap";
import { db } from "src/config/db";

var volume: number = 0.95;
setTimeout(async () => { const vol = (await db.settings.get({ name: 'volume'})); if (vol) { volume = Number(vol.value); console.log("Loaded settings volume", volume)} }, 100);
function setVolume(vol: number){
  volume = vol;
  db.settings.put({ name: 'volume', value: volume });
}

// export default class DrillSoundUtil {
class DrillSoundUtil {
  audioContext: AudioContext|null = null;
  // volume: number = 0.95;
  // running: boolean = false;

  // constructor() {
  //   // this.audioContext = new AudioContext(); // add this.audio_context.close() to somewhere
  // }

  stop = () => {
    // this.running = false;
    if (this.audioContext) {
      console.log("DrillSoundUtil closing AudioContext")
      this.audioContext.close();
      this.audioContext = null;
    }
  }
  start = () => {
    // this.running = true;
    console.log("DrillSoundUtil starting new AudioContext")
    this.audioContext = new AudioContext();
  }

  getVolume() {
    return volume;
  }


  // mainBeep = () => {
  //   this.customBeep({ duration: 300, frequency: 600 });
  // }

  // twoBeep = () => {
  //   // this.customBeep({ duration: 100, frequency: 1000 });

  //   let duration = 200 * 0.001;
  //   let delay = 200 * 0.001;
  //   let frequency = 1000;

  //   let oscillatorNode = this.audioContext.createOscillator();
  //   let gainNode = this.audioContext.createGain();
  //   oscillatorNode.connect(gainNode);
  //   oscillatorNode.frequency.value = frequency;
  //   oscillatorNode.type = "sine"; // "square";
  //   gainNode.connect(this.audioContext.destination);

  //   // Start audio with the desired duration
  //   oscillatorNode.start(this.audioContext.currentTime);
  //   oscillatorNode.stop(this.audioContext.currentTime + 2*duration + delay);

  //   let startTime = this.audioContext.currentTime
  //   let stopForDelay = startTime + duration;
  //   let startSecond = stopForDelay + delay;
  //   let stopTime = startSecond + duration;

  //   // http://alemangui.github.io/ramp-to-value
  //   gainNode.gain.value = 0.001;
  //   gainNode.gain.setValueAtTime(0.001, startTime)
  //   gainNode.gain.exponentialRampToValueAtTime(this.volume, startTime + 0.01);

  //   gainNode.gain.setValueAtTime(this.volume, stopForDelay - 0.01);
  //   gainNode.gain.exponentialRampToValueAtTime(0.001, stopForDelay);

  //   gainNode.gain.setValueAtTime(0.001, startSecond - 0.01);
  //   gainNode.gain.exponentialRampToValueAtTime(this.volume, startSecond);
  //   gainNode.gain.setValueAtTime(this.volume, stopTime - 0.01);
  //   gainNode.gain.exponentialRampToValueAtTime(0.001, stopTime);
  // }

  customBeep = ({ duration, frequency }: { duration: number, frequency: number }) => {
    // oscillator.type = "sine";
    // oscillator.frequency.value = 600;
    // oscillator.connect(this.audio_context.destination);
    // oscillator.start();
    // setTimeout(function () { oscillator.stop(); }, 150);

    return new Promise<void>((resolve, reject) => {
      if (volume === 0) {
        console.log("DrillSoundUtil.beep cancelled because volume === 0")
        return resolve();
      } else if (!this.audioContext) {
        console.log("DrillSoundUtil.beep tried when state was not running, cancelled")
        // reject("drillState.running was false")
        return resolve();
      }

      let vol = volume * 2 // For some reason web seemed to work better with scale from 0-2
      // console.log("DrillSoundUtil customBeep", duration, frequency, "time:", this.audioContext.currentTime)
      try {
        let oscillatorNode = this.audioContext.createOscillator();
        let gainNode = this.audioContext.createGain();
        oscillatorNode.connect(gainNode);
        oscillatorNode.frequency.value = frequency;
        // oscillatorNode.type = "sine"; // "square";
        oscillatorNode.type = "sine";
        gainNode.connect(this.audioContext.destination);

        let startTime = this.audioContext.currentTime
        let stopTime = startTime + duration * 0.001

        oscillatorNode.start(startTime);
        oscillatorNode.stop(stopTime);

        // http://alemangui.github.io/ramp-to-value
        gainNode.gain.value = 0.001;
        gainNode.gain.setValueAtTime(0.001, startTime)
        // gainNode.gain.exponentialRampToValueAtTime(this.volume, startTime + 0.02);
        // gainNode.gain.setValueAtTime(this.volume, stopTime - 0.02);
        gainNode.gain.exponentialRampToValueAtTime(vol, startTime + 0.02);
        gainNode.gain.setValueAtTime(vol, stopTime - 0.02);

        gainNode.gain.exponentialRampToValueAtTime(0.001, stopTime - 0.01);

        // Resolve the promise when the sound is finished
        oscillatorNode.onended = () => {
          // console.log("DrillSoundUtil.beep oscillatorNode ended", (this.audioContext ? this.audioContext.currentTime : "no time"))
          resolve();
        };
      } catch (error) {
        console.log("DrillSoundUtil.beep error: " + error)
        reject(error);
      }
    });
  }

  // playAudio = (audio: string) => { ....
  // let snd = new Audio("data:audio/wav;base64,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");
  // snd.play();
  // }

}

const drillSoundUtil = new DrillSoundUtil();
export default drillSoundUtil;


let iconBeepTimeout: null | number | NodeJS.Timeout = null;
let iconAudioContextCloseOnExit = false;

export function DrillSoundUtilVolumeIcon() {
  const [show, setShow] = useState(false);
  const [rangeValue, setRangeValue] = useState(volume);

  // const handleShow = () => setShow(true);
  // const handleClose = () => setShow(false);
  function handleShow() {
    setShow(true);
    iconAudioContextCloseOnExit = false
    if (!drillSoundUtil.audioContext) {
      iconAudioContextCloseOnExit = true;
      drillSoundUtil.start();
    }
  }
  function handleClose() {
    setShow(false);
    if (iconAudioContextCloseOnExit) {
      drillSoundUtil.stop();
    }
  }

  const changeVolume = (event: any) => {
    let vol = event.target.value;
    if (vol < 0.03) { vol = 0; } // mute if volume is very low
    setRangeValue(vol);
    setVolume(vol);
    console.log("Changed volume to ", vol, volume, iconBeepTimeout)

    clearTimeout(iconBeepTimeout!);
    iconBeepTimeout = setTimeout(() => {
      drillSoundUtil.customBeep({ duration: 200, frequency: 400 }); iconBeepTimeout = null },
      100);

    return true;
  }

  function icon() {
    if (rangeValue === 0) {
      return 'bi-volume-mute-fill';
    } else if (rangeValue < 0.80) {
      return 'bi-volume-down-fill';
    } else {
      return 'bi-volume-up-fill';
    }
  }

  function modal() {
    // react volume slider in bootstrap modal. This is called when we click on the volume icon in the footer
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title><i className={icon()}></i></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input type="range" className="form-range" value={rangeValue} min="0" max="1" step="0.02" id="drillSoundUtilVolumeRange"
                 onChange={changeVolume}></input>
        </Modal.Body>
      </Modal>
    )
  }

  return (
    <>
      <button className='btn' onClick={handleShow}><i className={`bi volume ${icon()}`}></i></button>
      {modal()}
    </>
  )

}
